module.exports = __webpack_public_path__ + "static/media/angry-emoji-emoticon-emotion-expression-feeling-svgrepo-com.b39dab13.svg";